(function () {
  if (window.CushyBumCartOffer) return;

  var fallbackRules = {
    giftVariants: {
      carryBag: '52936351514934',
      cushyBundle: '52936843559222'
    },
    cartWideGifts: {
      standardBagThreshold: 2,
      eofyBagThreshold: 1,
      bundleThreshold: 3
    },
    offers: [
      {
        id: 'standard-cushy-bum',
        variantIds: ['51849753264438'],
        productHandles: ['inflatable-travel-pillow'],
        tiers: [
          { minQuantity: 1, carryBagsPerUnit: 0, cushyBundleQuantity: 0 },
          { minQuantity: 2, carryBagsPerUnit: 1, cushyBundleQuantity: 0 },
          { minQuantity: 3, carryBagsPerUnit: 1, cushyBundleQuantity: 1 }
        ]
      },
      {
        id: 'eofy-cushy-bum',
        variantIds: ['54074976567606'],
        productHandles: [],
        tiers: [
          { minQuantity: 1, carryBagsPerUnit: 1, cushyBundleQuantity: 0 },
          { minQuantity: 3, carryBagsPerUnit: 1, cushyBundleQuantity: 1 }
        ]
      }
    ]
  };

  var syncPromise = null;

  function rules() {
    return window.CushyBumOfferRules || fallbackRules;
  }

  function giftVariants() {
    var giftConfig = rules().giftVariants || {};

    return {
      carryBag: String(giftConfig.carryBag || fallbackRules.giftVariants.carryBag),
      cushyBundle: String(giftConfig.cushyBundle || fallbackRules.giftVariants.cushyBundle)
    };
  }

  function variantId(item) {
    return String(item.variant_id || item.id || '');
  }

  function itemHandle(item) {
    return String(item.handle || item.product_handle || '').toLowerCase();
  }

  function itemUrl(item) {
    return String(item.url || '').toLowerCase();
  }

  function isPaidUpsell(item) {
    return !!(item.properties && item.properties._cb_paid_upsell);
  }

  function getCurrency(cart) {
    return (cart && cart.currency) || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'AUD';
  }

  function trackCartEvent(eventName, payload) {
    var eventPayload = Object.assign(
      {
        event: eventName,
        source: 'native_cart_drawer',
        timestamp: new Date().toISOString()
      },
      payload || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
    window.dispatchEvent(new CustomEvent(eventName, { detail: eventPayload }));

    try {
      var stored = JSON.parse(window.sessionStorage.getItem('cbCartAnalytics') || '{"upsellClicks":0,"upsellAdds":0,"upsellValueCents":0}');

      if (eventName === 'cushy_bum_cart_upsell_clicked') {
        stored.upsellClicks += 1;
      }
      if (eventName === 'cushy_bum_cart_upsell_added') {
        stored.upsellAdds += 1;
        stored.upsellValueCents += Number(eventPayload.value_cents || 0);
      }

      window.sessionStorage.setItem('cbCartAnalytics', JSON.stringify(stored));
    } catch (error) {
      console.warn('Cushy Bum cart analytics storage failed', error);
    }
  }

  function isAutoGift(item) {
    if (isPaidUpsell(item)) return false;

    var gifts = giftVariants();
    var id = variantId(item);

    return id === gifts.carryBag || id === gifts.cushyBundle;
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      return response.json();
    });
  }

  function getCartWithSections() {
    return getCart().then(attachSections);
  }

  function attachSections(cart) {
    var sectionIds = getSections();
    var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.join(','));

    return fetch(url, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        cart.sections = sections;
        return cart;
      });
  }

  function sortedTiers(offer) {
    return (offer.tiers || []).slice().sort(function (a, b) {
      return Number(a.minQuantity || 0) - Number(b.minQuantity || 0);
    });
  }

  function bestTier(offer, quantity) {
    var match = null;

    sortedTiers(offer).forEach(function (tier) {
      if (quantity >= Number(tier.minQuantity || 0)) {
        match = tier;
      }
    });

    return match;
  }

  function matchesOffer(item, offer) {
    var id = variantId(item);
    var handle = itemHandle(item);
    var url = itemUrl(item);

    if ((offer.variantIds || []).map(String).indexOf(id) !== -1) return true;

    return (offer.productHandles || []).some(function (productHandle) {
      var normalized = String(productHandle || '').toLowerCase();
      return normalized && (handle === normalized || url.indexOf('/products/' + normalized) !== -1);
    });
  }

  function expectedGifts(cart) {
    var expected = {
      cushyBumQuantity: 0,
      carryBags: 0,
      cushyBundle: 0,
      standardQuantity: 0,
      eofyQuantity: 0,
      offers: []
    };
    var cartWideGifts = rules().cartWideGifts || fallbackRules.cartWideGifts;
    var totalStandardQuantity = 0;
    var totalEofyQuantity = 0;

    (rules().offers || []).forEach(function (offer) {
      var quantity = 0;

      (cart.items || []).forEach(function (item) {
        if (matchesOffer(item, offer)) {
          quantity += item.quantity || 0;
        }
      });

      if (!quantity) return;

      var tier = bestTier(offer, quantity);
      var carryBags = tier ? quantity * Number(tier.carryBagsPerUnit || 0) : 0;
      var cushyBundle = tier ? Number(tier.cushyBundleQuantity || 0) : 0;

      expected.cushyBumQuantity += quantity;
      if (offer.id === 'eofy-cushy-bum') {
        totalEofyQuantity += quantity;
      } else {
        totalStandardQuantity += quantity;
      }
      expected.offers.push({
        id: offer.id,
        label: offer.label || offer.id,
        quantity: quantity,
        carryBags: carryBags,
        cushyBundle: cushyBundle
      });
    });

    expected.standardQuantity = totalStandardQuantity;
    expected.eofyQuantity = totalEofyQuantity;

    if (expected.cushyBumQuantity >= Number(cartWideGifts.standardBagThreshold || 2)) {
      expected.carryBags = expected.cushyBumQuantity;
    } else if (totalEofyQuantity >= Number(cartWideGifts.eofyBagThreshold || 1)) {
      expected.carryBags = totalEofyQuantity;
    }

    if (expected.cushyBumQuantity >= Number(cartWideGifts.bundleThreshold || 3)) {
      expected.cushyBundle = 1;
    }

    return expected;
  }

  function giftLineSummary(cart, targetVariantId) {
    var summary = {
      quantity: 0,
      lines: []
    };

    (cart.items || []).forEach(function (item) {
      if (variantId(item) !== targetVariantId || !isAutoGift(item)) return;

      summary.quantity += item.quantity || 0;
      summary.lines.push(item);
    });

    return summary;
  }

  function updateCartLines(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function addGiftItems(items) {
    if (!items.length) return Promise.resolve(null);

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function lineUpdatesForGift(cart, targetVariantId, expectedQuantity) {
    var summary = giftLineSummary(cart, targetVariantId);

    if (summary.quantity <= expectedQuantity) return {};

    var quantityToRemove = summary.quantity - expectedQuantity;
    var updates = {};

    summary.lines.forEach(function (line) {
      if (!quantityToRemove) return;

      var lineQuantity = line.quantity || 0;
      var nextQuantity = lineQuantity;

      if (quantityToRemove >= lineQuantity) {
        nextQuantity = 0;
        quantityToRemove -= lineQuantity;
      } else {
        nextQuantity = lineQuantity - quantityToRemove;
        quantityToRemove = 0;
      }

      updates[line.key] = Math.max(0, nextQuantity);
    });

    return updates;
  }

  function missingGiftItems(cart, targetVariantId, expectedQuantity) {
    var summary = giftLineSummary(cart, targetVariantId);
    var missingQuantity = expectedQuantity - summary.quantity;

    if (missingQuantity <= 0) return [];

    return [
      {
        id: String(targetVariantId),
        quantity: missingQuantity,
        properties: {
          _cb_auto_gift: 'true'
        }
      }
    ];
  }

  function buildGiftPlan(cart) {
    var expected = expectedGifts(cart);
    var gifts = giftVariants();
    var updates = Object.assign(
      {},
      lineUpdatesForGift(cart, gifts.carryBag, expected.carryBags),
      lineUpdatesForGift(cart, gifts.cushyBundle, expected.cushyBundle)
    );
    var additions = missingGiftItems(cart, gifts.carryBag, expected.carryBags).concat(
      missingGiftItems(cart, gifts.cushyBundle, expected.cushyBundle)
    );

    return {
      expected: expected,
      additions: additions,
      updates: updates,
      hasChanges: additions.length > 0 || Object.keys(updates).length > 0
    };
  }

  function applyGiftPlan(cart) {
    var plan = buildGiftPlan(cart);
    var work = Promise.resolve(cart);

    if (Object.keys(plan.updates).length) {
      work = work.then(function () {
        return updateCartLines(plan.updates);
      });
    }

    if (plan.additions.length) {
      work = work.then(function () {
        return addGiftItems(plan.additions);
      });
    }

    if (!plan.hasChanges) return work;

    return work.then(getCart);
  }

  function giftsAreCharged(cart) {
    return false;
  }

  function removeGiftLines(cart) {
    return Promise.resolve(cart);
  }

  function refreshDrawerFromState(state) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && state && state.sections && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(state);
    }
    return state;
  }

  function getSections() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function renderCartState(parsedState, openDrawer) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !parsedState || !parsedState.sections || typeof cartDrawer.renderContents !== 'function') {
      return parsedState;
    }

    cartDrawer.renderContents(parsedState);

    if (!openDrawer) {
      window.setTimeout(function () {
        if (cartDrawer.classList.contains('active')) return;
        cartDrawer.close();
      }, 0);
    }

    return parsedState;
  }

  function showDiscountWarning() {
    return;
  }

  function updateGifts(options) {
    options = options || {};

    if (syncPromise) return syncPromise;

    document.documentElement.classList.add('cb-cart-syncing');

    syncPromise = getCart()
      .then(function (cart) {
        return applyGiftPlan(cart);
      })
      .then(function (nextCart) {
        window.sessionStorage.removeItem('cbGiftDiscountMissing');
        return attachSections(nextCart);
      })
      .then(function (state) {
        document.documentElement.classList.remove('cb-cart-syncing');
        syncPromise = null;
        return state;
      })
      .catch(function (error) {
        document.documentElement.classList.remove('cb-cart-syncing');
        syncPromise = null;
        console.error('Cushy Bum gift sync failed', error);
        return options.fallbackState || null;
      });

    return syncPromise;
  }

  function syncAndRender(options) {
    options = options || {};

    return updateGifts(options).then(function (state) {
      if (state && state.sections) {
        renderCartState(state, options.openDrawer);
      }
      if (window.sessionStorage.getItem('cbGiftDiscountMissing') === 'true') {
        showDiscountWarning();
      }
      return state;
    });
  }

  function addPaidUpsell(variantIdToAdd, button) {
    if (!variantIdToAdd || !window.routes) return Promise.resolve(null);

    var upsellTitle = button ? button.getAttribute('data-product-title') : '';
    var upsellValueCents = button ? Number(button.getAttribute('data-price-cents') || 0) : 0;

    trackCartEvent('cushy_bum_cart_upsell_clicked', {
      variant_id: String(variantIdToAdd),
      product_title: upsellTitle,
      value_cents: upsellValueCents
    });

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding';
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: String(variantIdToAdd),
        quantity: 1,
        properties: {
          _cb_paid_upsell: 'true'
        },
        sections: getSections(),
        sections_url: window.location.pathname
      })
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        trackCartEvent('cushy_bum_cart_upsell_added', {
          variant_id: String(variantIdToAdd),
          product_title: state.product_title || upsellTitle,
          value_cents: state.final_line_price || state.line_price || upsellValueCents,
          currency: getCurrency(state)
        });
        return state;
      })
      .then(refreshDrawerFromState)
      .catch(function (error) {
        console.error('Cushy Bum upsell add failed', error);
      })
      .finally(function () {
        if (!button) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Add';
      });
  }

  function offerVariantIds() {
    var ids = [];

    (rules().offers || []).forEach(function (offer) {
      (offer.variantIds || []).forEach(function (id) {
        ids.push(String(id));
      });
    });

    return ids;
  }

  function formHasCushyBum(form) {
    if (!form) return false;

    var ids = offerVariantIds();
    var idInput = form.querySelector('[name="id"]');

    if (idInput && ids.indexOf(String(idInput.value)) !== -1) {
      return true;
    }

    return ids.some(function (id) {
      return !!form.querySelector('[value="' + id + '"]');
    });
  }

  window.CushyBumCartOffer = {
    CUSHY_BUM_VARIANT_ID: '51849753264438',
    CUSHY_BUM_EOFY_VARIANT_ID: '54074976567606',
    CARRY_BAG_VARIANT_ID: giftVariants().carryBag,
    CUSHY_BUNDLE_VARIANT_ID: giftVariants().cushyBundle,
    buildGiftPlan: buildGiftPlan,
    expectedGifts: expectedGifts,
    formHasCushyBum: formHasCushyBum,
    sync: updateGifts,
    syncAndRender: syncAndRender,
    addPaidUpsell: addPaidUpsell
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cb-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();
    addPaidUpsell(button.getAttribute('data-variant-id'), button);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cushy-bum-cart-offer') return;
      window.setTimeout(function () {
        syncAndRender({ openDrawer: true });
      }, 0);
    });
  }
})();
